import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useAppSelector } from 'hooks/reduxHooks'

function getPhoneHref(phoneNumber: string) {
  return `tel:${phoneNumber.replace(/\s/g, '')}`
}

function getEmailHref(email: string) {
  return `mailto:${email}`
}

/**
 * Concierge contact details for the logged-in Infinite member, derived from their assigned
 * `customerServiceRep`. Returns `null` when no rep is assigned — callers should hide the concierge
 * surface entirely rather than showing placeholder details.
 */
function useInfiniteConciergeDetails() {
  const intl = useIntl()
  const customerServiceRep = useAppSelector(state => state.loyalty.account.data?.customerServiceRep)

  return useMemo(() => {
    if (!customerServiceRep) return null

    const phoneNumber = customerServiceRep.phone
    const phoneDialNumber = phoneNumber.replace(/\s/g, '')
    const email = customerServiceRep.email

    return {
      name: `${customerServiceRep.firstName} ${customerServiceRep.lastName}`,
      title: intl.formatMessage({
        id: '4ZafDD1T0XtrNw7-MVr1',
        defaultMessage: 'Your Dedicated Concierge',
        description: 'Title shown for Infinite members dedicated concierge support in navigation contact menus',
      }),
      phoneNumber,
      phoneDialNumber,
      phoneHref: getPhoneHref(phoneDialNumber),
      email,
      emailHref: getEmailHref(email),
    }
  }, [customerServiceRep, intl])
}

export default useInfiniteConciergeDetails
